const chars: Record<string, string> = {
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  À: 'A',
  Á: 'A',
  Â: 'A',
  Ã: 'A',
  Ä: 'A',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  È: 'E',
  É: 'E',
  Ê: 'E',
  Ë: 'E',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  Ì: 'I',
  Í: 'I',
  Î: 'I',
  ò: 'o',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  Ò: 'O',
  Ó: 'O',
  Ô: 'O',
  Õ: 'O',
  Ö: 'O',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u',
  Ù: 'U',
  Ú: 'U',
  Û: 'U',
  Ü: 'U',
  ç: 'c',
  Ç: 'C',
  ñ: 'n',
  Ñ: 'N',
};

export const replaceSpecialChars = (s: string): string => {
  if (!s) return '';
  return s.replace(/[àáâãäèéêëìíîïòóôõöùúûüÀÁÂÃÄÈÉÊËÌÍÎÒÓÔÕÖÙÚÛÜçÇñÑ]/g, m => chars[m] ?? m);
};
